import { createFileRoute } from "@tanstack/react-router";
import PageContent from "@/components/PageContent";

export const Route = createFileRoute('/(redirects)/$')({
  component: ErrorPage,
})

function ErrorPage() {
  return (
    <PageContent>
      <div className="text-center">
        <h1>
          Page Not Found
        </h1>
        <p>
          If you got here by clicking a link, that link is broken.
        </p>
        <p>
          <span className="text-lg italic">Please,</span> let us know. Thank you.
        </p>
        <p className="mx-4 my-2">&mdash; EVTCC</p>
      </div>
    </PageContent>
  );
}
